import React from 'react';
import {ProspectPool} from 'api';
import {Link} from 'react-router-dom';

interface ProspectPoolInfoProps {
  prospectPool: ProspectPool;
}

export const ProspectPoolInfo: React.FC<ProspectPoolInfoProps> = ({
  prospectPool,
}) => {
  const prospect = prospectPool?.prospect;
  const poolId = prospectPool?.pool?.uuid;
  const fullName = [prospect?.lastName, prospect?.firstName]
    .filter(Boolean)
    .join(' ');
  
  let url = `/pools/${poolId}/prospects/${prospectPool.uuid}/timeline`;
  if (fullName !== '') {
    url += `?searchWord=${encodeURIComponent(fullName)}`;
  }
  
  return (
    <div>
      <div className="text-lg font-bold text-c-primary cursor-pointer">
        <Link
          to={url}
          target="_blank"
          rel="noopener noreferrer">
          {fullName}
        </Link>
      </div>
      <div className="text-sm text-gray-700">
        {prospectPool.accountPool?.account?.name}
      </div>
    </div>
  );
};
